import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Card from '../edit-page/Card';
import renderField from '../edit-page/fields/FieldExtensions';
import CustomerStore from '../../store/customerStore'

const CustomerAccess = observer(
    class CustomerAccess extends Component {
        render() {
            let isEditable = CustomerStore.accessEditable;
            let model = CustomerStore.formModel.access

            return (
                <Card
                    helpInfo={this.props.helpInfo}
                    label="Access"
                    editableMode={true}
                    editable={isEditable}
                    onEditButtonClick={() => CustomerStore.accessEditable = !isEditable}>
                    <div className="row row-no-outer-gutter">
                        <div className="column-6 column-xs-12">
                            {renderField(model.scope, isEditable, '', () => CustomerStore.setDirty(true))}
                        </div>
                    </div>
                </Card>
            )
        }
    }
)

export default CustomerAccess;